import { createSlice } from '@reduxjs/toolkit';
import { User } from 'global/types';

interface UserState {
    isAuthenticating: boolean;
    user: User;
};

const initialState: UserState = {
    isAuthenticating: true, 
    user: null
};

export const userSlice = createSlice({
    name: 'user',
    initialState, 
    reducers: {
        signIn: (state, action) => {
            state.isAuthenticating = false;
            state.user = action.payload;
        },
        signOut: state => {
            state.isAuthenticating = false;
            state.user = null;
        }
    }
});

export const { signIn, signOut } = userSlice.actions;

export default userSlice.reducer;